import type { Action, PayloadAction } from '@reduxjs/toolkit';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { FetchBaseQueryArgs } from '@reduxjs/toolkit/query';

import { defaultQueryOptions, globalConfig } from './config';

const isHydrateAction = (action: Action): action is PayloadAction<Record<string, any>> => {
  return globalConfig.hydrateActionType ? action.type === globalConfig.hydrateActionType : false;
};

// initialize an empty api service that will be used by the api code generator
export const emptyApi = createApi({
  baseQuery: (args, api, extraOptions) => {
    const mergedQueryOptions: FetchBaseQueryArgs = {
      ...defaultQueryOptions,
      ...(globalConfig.defaultQueryOptions || {}),
      ...(globalConfig.getQueryOptions ? globalConfig.getQueryOptions(api.getState()) : {}),
    };
    return fetchBaseQuery(mergedQueryOptions)(args, api, extraOptions);
  },
  endpoints: () => ({}),
  extractRehydrationInfo: (action, { reducerPath }): any => {
    if (isHydrateAction(action)) {
      return action.payload[reducerPath];
    }
  },
});
